import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getHelpChatLog, getHelpChatSession, getHelpChatStats, listHelpChatLogs } from '../../lib/adminApi';
import type { HelpChatLogsFilters } from '../../types/admin';
import { adminKeys } from './adminQueryKeys';

export function useHelpChatLogs(filters: HelpChatLogsFilters) {
  return useQuery({
    queryKey: adminKeys.helpChat.logs(filters as Record<string, unknown>),
    queryFn: () => listHelpChatLogs(filters),
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
  });
}

export function useHelpChatLog(id: string | null) {
  return useQuery({
    queryKey: adminKeys.helpChat.log(id ?? ''),
    queryFn: () => getHelpChatLog(id as string),
    enabled: Boolean(id),
  });
}

export function useHelpChatSession(sessionId: string | null, enabled: boolean) {
  return useQuery({
    queryKey: adminKeys.helpChat.session(sessionId ?? ''),
    queryFn: () => getHelpChatSession(sessionId as string),
    enabled: enabled && Boolean(sessionId),
  });
}

export function useHelpChatStats(days: number) {
  return useQuery({
    queryKey: adminKeys.helpChat.stats(days),
    queryFn: () => getHelpChatStats(days),
    placeholderData: keepPreviousData,
    staleTime: 60 * 1000,
  });
}
